import { useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, Row, Col, message, Select } from "antd";
import { handleFetchLocations } from "../../../../api/locations";
import { handleUpdateVehicleLocation } from "../../../../api/vehicles";
const { Option } = Select;

export default function UpdateLocation({
  isVisible,
  setVisible,
  vehicle,
  chassis,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { data: locations } = useQuery({
    queryKey: ["locations"],
    queryFn: handleFetchLocations,
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: handleUpdateVehicleLocation,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["vehicles", chassis] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const locationOptions = locations?.map((location: any, index: number) => (
    <Option value={location?._id} key={index}>
      {location?.name}
    </Option>
  ));

  const onSubmit = async () => {
    const { location } = await form.getFieldsValue();
    const data = {
      location,
    };
    await mutate({ data, chassis: vehicle?.chassis });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.setFieldsValue({ ...vehicle });
  }, [vehicle]);

  return (
    <Modal
      open={isVisible}
      title="Update Location"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateVehLoc"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="updateVehLoc"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="location"
              label="Select Location"
              rules={[
                {
                  required: true,
                  message: "Please select location",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search and select location"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {locationOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
